import { react2panel } from 'common/util/react2panel';
import { LinkTooltip } from './link-tooltip';
export const LinkTooltipPanel = react2panel("mp-link-tooltip", LinkTooltip);